import React from 'react';

const SetupListSelectHeader = ({ headerClicked, disabled }) => {

  const checkStyle = {
    width: '25px',
    height: '25px',
    transform: 'translate(-7px, 2px)'
  };

  return (
    <div>
        <input type="checkbox" style={checkStyle} onChange={headerClicked} disabled={disabled}/>
    </div>
  );
};

export default SetupListSelectHeader;